// extracted by mini-css-extract-plugin
module.exports = {"onlyTextContainerSection":"AgencyHomeTextOnlySlider_onlyTextContainerSection__ten_V","onlyTextContainer":"AgencyHomeTextOnlySlider_onlyTextContainer__QCgXE"};